export const ANNOTATION_COLORS = {
  yellow: "#FBBF24",
  orange: "#FB923C",
  lightBlue: "#60A5FA",
  teal: "#2DD4BF",
  purple: "#A78BFA",
  pink: "#F472B6",
} as const;

export type AnnotationColor =
  (typeof ANNOTATION_COLORS)[keyof typeof ANNOTATION_COLORS];

export const ANNOTATION_COLOR_LIST: AnnotationColor[] =
  Object.values(ANNOTATION_COLORS);

export const DEFAULT_ANNOTATION_COLOR = ANNOTATION_COLORS.yellow;

export const ANNOTATION_ICON_NAMES = [
  "StickyNote",
  "Bookmark",
  "Star",
  "AlertTriangle",
  "CheckCircle",
  "Flag",
  "Heart",
  "Lightbulb",
  "MessageCircle",
  "Pencil",
  "Pin",
  "Zap",
] as const;

export type AnnotationIconName = (typeof ANNOTATION_ICON_NAMES)[number];

export const DEFAULT_ANNOTATION_ICON: AnnotationIconName = "StickyNote";

export interface PageAnnotation {
  id: string;
  pageId: string;
  folderId: string;
  authorId: string;
  content: string;
  title?: string;
  color: string;
  icon?: string;
  positionX: number;
  positionY: number;
  createdAt: string;
  updatedAt: string;
}

export interface CreatePageAnnotationBody {
  content: string;
  title?: string;
  color?: string;
  icon?: string;
  positionX?: number;
  positionY?: number;
}

export interface UpdatePageAnnotationBody {
  content?: string;
  title?: string;
  color?: string;
  icon?: string;
  positionX?: number;
  positionY?: number;
}

export interface GetPageAnnotationsResponse {
  annotations: PageAnnotation[];
}
